import { NavLink } from 'react-router-dom';
import { Home, FolderKanban, ListTodo, Users, ShieldAlert, Menu, X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useState, useEffect } from 'react';

const navigation = [
  { name: 'Home', path: '/', icon: Home },
  { name: 'Projetos', path: '/projetos', icon: FolderKanban },
  { name: 'Tarefas', path: '/tarefas', icon: ListTodo },
  { name: 'Agentes', path: '/agentes', icon: Users },
  { name: 'Segurança', path: '/guards', icon: ShieldAlert },
];

export function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setIsOpen(false);
      }
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <>
      {/* Mobile Menu Button */}
      {isMobile && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed top-4 left-4 z-40 p-2 rounded-md bg-primary/10 border border-primary/20 md:hidden"
          data-testid="mobile-menu-btn"
        >
          <Menu className="h-6 w-6 text-primary" />
        </button>
      )}

      {/* Backdrop */}
      {isMobile && isOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 md:hidden"
          onClick={() => setIsOpen(false)}
          data-testid="sidebar-backdrop"
        />
      )}

      {/* Sidebar */}
      <aside
        className={cn(
          'flex flex-col border-r border-border/50 bg-[#121215] transition-transform duration-300 ease-in-out',
          'md:relative md:translate-x-0',
          'fixed inset-y-0 left-0 z-50 w-64',
          isMobile && !isOpen && '-translate-x-full'
        )}
        data-testid="sidebar"
      >
        <div className="flex h-16 items-center justify-between border-b border-border/50 px-4">
          <h1 className="font-heading text-xl font-bold tracking-tight text-primary" data-testid="app-title">
            HQ CONTROL
          </h1>
          {isMobile && (
            <button
              onClick={() => setIsOpen(false)}
              className="rounded-sm p-1.5 hover:bg-accent transition-colors"
              data-testid="sidebar-close"
            >
              <X className="h-5 w-5" />
            </button>
          )}
        </div>

        <nav className="flex-1 space-y-1 p-3" data-testid="sidebar-nav">
          {navigation.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={() => isMobile && setIsOpen(false)}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-sm px-3 py-2.5 text-sm font-medium transition-colors',
                  'hover:bg-accent hover:text-accent-foreground',
                  isActive
                    ? 'bg-primary/10 text-primary border border-primary/20'
                    : 'text-muted-foreground'
                )
              }
              data-testid={`nav-${item.name.toLowerCase()}`}
            >
              <item.icon className="h-5 w-5 flex-shrink-0" />
              <span className="uppercase tracking-wider text-xs">{item.name}</span>
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-border/50 p-4">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-sm bg-primary/10 border border-primary/20">
              <ShieldAlert className="h-5 w-5 text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-mono text-muted-foreground truncate">v0.1.0-alpha</p>
              <p className="text-[10px] text-muted-foreground/60 uppercase">Mission Control</p>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}
